import { Stack } from 'tamagui'

export default function CobuSpacer({ size = '$2', horizontal = false }: { size?: any; horizontal?: boolean }) {
  return <Stack width={horizontal ? size : undefined} height={!horizontal ? size : undefined} />
}
